// Keep one untouched source snapshot so color removal can always be reversed.
const cloneSnapshot = (value) => {
  if (Array.isArray(value)) return value.map(cloneSnapshot);
  if (value && typeof value === "object") return Object.fromEntries(
    Object.entries(value).map(([key, entry]) => [key, cloneSnapshot(entry)]),
  );
  return value;
};

const normalizeTolerance = (value) => Math.min(80, Math.max(0, Number(value) || 0));
const normalizeColor = (value) => {
  const color = String(value || "").trim();
  if (!/^#[0-9a-f]{6}$/i.test(color)) throw new Error("請選擇有效的背景顏色。");
  return color.toLowerCase();
};

export const getBackgroundRemovalAsset = (image = {}) => image.backgroundRemoval?.redrawAsset || image.backgroundRemoval?.originalAsset || image.asset || {};

export const getBackgroundRemovalSource = (image = {}) => {
  const asset = getBackgroundRemovalAsset(image);
  return [asset._preview_url, asset._previewUrl, asset.url].map((url) => String(url || "").trim()).find(Boolean) || "";
};

export const removeBackgroundPixels = (pixels, colorHex, tolerance = 0) => {
  const color = normalizeColor(colorHex);
  const rgb = [1, 3, 5].map((offset) => parseInt(color.slice(offset, offset + 2), 16));
  const limit = normalizeTolerance(tolerance);
  const result = new Uint8ClampedArray(pixels);
  for (let offset = 0; offset + 3 < result.length; offset += 4) {
    if (rgb.every((channel, index) => Math.abs(result[offset + index] - channel) <= limit)) {
      result[offset + 3] = 0;
    }
  }
  return result;
};

export const applyBackgroundRemoval = (image, { dataUrl, color, tolerance }) => {
  if (!/^data:image\/png;base64,[a-z0-9+/=]+$/i.test(String(dataUrl || ""))) {
    throw new Error("無法產生透明 PNG 圖片，請重新處理。");
  }
  const originalAsset = cloneSnapshot(image.backgroundRemoval?.originalAsset || image.asset || {});
  return {
    ...image,
    asset: {
      ...(image.asset || {}), url: dataUrl, mime_type: "image/png",
      source_code: "", source_language: "", storage_key: "",
      _preview_url: "", _previewUrl: "", _preview_source_code: "",
    },
    backgroundRemoval: {
      ...(image.backgroundRemoval || {}), originalAsset,
      color: normalizeColor(color), tolerance: normalizeTolerance(tolerance),
    },
  };
};

export const restoreImageBackground = (image) => {
  if (!image.backgroundRemoval?.originalAsset) return image;
  const { backgroundRemoval, ...restored } = image;
  return { ...restored, asset: cloneSnapshot(backgroundRemoval.originalAsset) };
};
